import { render } from "./OffcanvasContent.vue?vue&type=template&id=785cb92e"
import script from "./OffcanvasContent.vue?vue&type=script&lang=js"
export * from "./OffcanvasContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__